export const DEFAULT_RESULTS_PER_PAGE = 20;
